import type { ConsentStatus } from "./consent";

/**
 * The consent gate's decision function, pulled out as pure logic so it is
 * verifiable without rendering the whole app (AppWithConfig.tsx wires
 * KindeProvider + urql + the router, which is expensive to mock just to
 * prove a boolean).
 *
 * initAnalytics() may be called once BOTH halves are true: config has
 * resolved (a loading render always carries an undefined posthogKey, and
 * initialising then would burn the "exactly once" contract on an absent
 * key) AND the visitor has affirmatively accepted the cookie-consent
 * banner. Declining, or not having answered yet, must produce the same
 * answer — false — so no PostHog network request is ever made either way.
 */
export function shouldInitAnalytics(configIsLoading: boolean, consentStatus: ConsentStatus): boolean {
  return !configIsLoading && consentStatus === "accepted";
}
